import PackageConfiguration from '../interfaces/PackageConfiguration';

const getDomainName = () => {
  if (process.env.REACT_APP_DOMAIN_NAME) {
    return process.env.REACT_APP_DOMAIN_NAME;
  }

  return document.location.host;
};

const useClassicEngine = process.env.REACT_APP_USE_CLASSIC_ENGINE === 'true';
const isOktaHosting = !useClassicEngine || process.env.REACT_APP_IS_OKTA_HOSTING === 'true';
const prefillUsername = !process.env.REACT_APP_PREFILL_USERNAME || process.env.REACT_APP_PREFILL_USERNAME === 'true';

export default class Configuration {
  private static config: PackageConfiguration = {
    awAccountManagement: process.env.REACT_APP_AW_ACCOUNT_MANAGEMENT,
    businessEntityCode: process.env.REACT_APP_BUSINESS_ENTITY_CODE,
    forgetPasswordPath: process.env.REACT_APP_FORGET_PASSWORD_PATH,
    forgetUserNamePath: process.env.REACT_APP_FORGET_USERNAME_PATH,
    idpTenantUrl: isOktaHosting ? `${document.location.origin}${process.env.REACT_APP_IDP_TENANT_URL_SUFFIX ? process.env.REACT_APP_IDP_TENANT_URL_SUFFIX : ''}` : process.env.REACT_APP_IDP_TENANT_URL,
    registrationPath: process.env.REACT_APP_REGISTRATION_PATH,
    userType: process.env.REACT_APP_USER_TYPE,
    domainName: getDomainName(),
    publicUrl: process.env.PUBLIC_URL,
    useIdPDiscovery: process.env.REACT_APP_USE_IDP_DISCOVERY === 'true',
    featuresRouter: !process.env.REACT_APP_USE_ROUTER || process.env.REACT_APP_USE_ROUTER === 'true',
    useClassicEngine,
    isOktaHosting,
    prefillUsername,
  };

  public static Current(): PackageConfiguration { return Configuration.config; }
}
